module.exports = __webpack_public_path__ + "img/25.d0490764.jpg";